import React from "react";
import PropTypes from "prop-types";
import styles from "./CartTotalDetails.module.css";
import { useTranslation } from "react-i18next";

export function CartTotalDetails({
  subTotal,
  tax,
  shippingFee,
  total,
  onCheckout,
  onPurchase,
  onCancel,
  checkoutClicked,
  isSubmitting = false,
  disableCheckout = false,
}) {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.buttonContainer}>
        {!checkoutClicked ? (
          <button
            type="button"
            onClick={onCheckout}
            className={styles.checkoutBtn}
            disabled={subTotal <= 0 || isSubmitting || disableCheckout}
          >
            {t("Checkout")}
          </button>
        ) : (
          <>
            <button
              type="button"
              onClick={onCancel}
              className={styles.cancelBtn}
              disabled={isSubmitting}
            >
              {t("Cancel")}
            </button>
            <button
              type="button"
              onClick={onPurchase}
              className={styles.purchaseBtn}
              disabled={isSubmitting}
            >
              {t("Place Your Order")}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

CartTotalDetails.propTypes = {
  subTotal: PropTypes.number.isRequired,
  tax: PropTypes.number.isRequired,
  shippingFee: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onCheckout: PropTypes.func.isRequired,
  onPurchase: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  checkoutClicked: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool,
  disableCheckout: PropTypes.bool,
};

export default CartTotalDetails;
